// Google Maps JS API is loaded globally
const geocoder = new window.google.maps.Geocoder()

function extractCity(result) {
  return result.find((r) => r.types.includes('locality')).long_name
}
function extractStateAbbr(result) {
  return result.find((r) => r.types.includes('administrative_area_level_1')).short_name
}
function extractLatLong(result) {
  return result.geometry.location || {}
}

export default {
  async searchByZip(zip, streetAddress) {
    let address = ''
    if (streetAddress) {
      address = `street_address:${streetAddress}|`
    }
    const params = {
      address: `${address}postal_code:${zip}|region:US`
    }

    return new Promise((resolve, reject) => {
      geocoder.geocode(params, function(results, status) {
        // ref for list of status values: https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingStatusCodes
        if (status !== 'OK') {
          reject('Error')
        }
        try {
          const firstResult = results[0].address_components
          const latLong = extractLatLong(results[0])
          resolve({
            address: {
              city: extractCity(firstResult),
              state: extractStateAbbr(firstResult),
              zip,
              lat: latLong.lat() || null,
              lng: latLong.lng() || null
            }
          })
        } catch (error) {
          console.log('error')
          reject({})
        }
      })
    })

    /*

    const response = await gmaps.geocode(params).asPromise()

    */
  }
}
